import {Col, Card, Image} from "react-bootstrap";
import {CarModel} from "../../../features/season/seasonTypes";


type Props = {
    car: CarModel;
    selectedCarId: number | 0;
    setSelectedCarId: (id: number | 0) => void;
};

const CarItemForm = ({car, selectedCarId, setSelectedCarId}: Props) => {
    const handleClick = () => {
        if (car.id === selectedCarId) {
            setSelectedCarId(0);
        } else {
            setSelectedCarId(car.id);
            console.log(car.id)
        }
    };

    const borderClass = car.id === selectedCarId ? "selected" : " ";

    return (
        <>
            <Col xs={6}
                 md={4}
                 className={`mt-3 mb-3 gap-2 p-1 car-card ${borderClass}`}
                 data-id={car.id}
                 onClick={handleClick}
            >
                <Card.Img variant="top" as={Image} src={car.image} alt={car.name}/>
                <Card.Body className="text-center">
                    <Card.Title>{car.fullname}</Card.Title>
                </Card.Body>
            </Col>
        </>
    );
};

export default CarItemForm;